export const TARGET_PERIOD_PLACEHOLDER = "e.g. 2026 Q3";
export const QUARTER_PATTERN = /^(\d{4}) Q([1-4])$/;

export const isValidTargetPeriod = (period) =>
  period === "" || QUARTER_PATTERN.test(period);

/*
 * Parses <#### Q#> into a comparable integer for sorting.
 * Returns 0 for unset/unparseable values so they sort before any real period.
 */
export const parseTargetPeriod = (period) => {
  const match = QUARTER_PATTERN.exec(period || "");
  if (!match) return 0;
  const [, year, quarter] = match;
  return parseInt(year, 10) * 4 + parseInt(quarter, 10);
};

/*
 * Inverse of parseTargetPeriod.
 * Turns a quarter index back into <#### Q#>.
 */
export const formatQuarterIndex = (index) => {
  if (index <= 0) return "";
  const year = Math.floor((index - 1) / 4);
  const quarter = index - year * 4;
  return `${year} Q${quarter}`;
};

export const getCurrentQuarterIndex = () => {
  const now = new Date();
  return now.getFullYear() * 4 + Math.floor(now.getMonth() / 3) + 1;
};
